'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var debug = require('debug');

var errors = require('datastore-core/errors');

var parallelBatch = require('it-parallel-batch');

var itPipe = require('it-pipe');

var merge = require('it-merge');

var map = require('it-map');

var filter = require('it-filter');

var key = require('interface-datastore/key');

var base32 = require('multiformats/bases/base32');

var walkDag = require('./utils/walk-dag.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var parallelBatch__default = /*#__PURE__*/_interopDefaultLegacy(parallelBatch);

var merge__default = /*#__PURE__*/_interopDefaultLegacy(merge);

var map__default = /*#__PURE__*/_interopDefaultLegacy(map);

var filter__default = /*#__PURE__*/_interopDefaultLegacy(filter);

var log = debug__default["default"]('ipfs:repo:gc');
var ERR_NOT_FOUND = errors.notFoundError().code;
var BLOCK_RM_CONCURRENCY = 256;
var MFS_ROOT_KEY = new key.Key('/local/filesroot');

function gc(_ref2) {
  var gcLock = _ref2.gcLock,
      pins = _ref2.pins,
      blockstore = _ref2.blockstore,
      root = _ref2.root,
      loadCodec = _ref2.loadCodec;

  function gc() {
    return _gc.apply(this, arguments);
  }

  function _gc() {
    _gc = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var start, release, markedSet, blockKeys;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              start = Date.now();
              log('Creating set of marked blocks');
              _context.next = 4;
              return _awaitAsyncGenerator(gcLock.writeLock());

            case 4:
              release = _context.sent;
              _context.prev = 5;
              _context.next = 8;
              return _awaitAsyncGenerator(createMarkedSet({
                pins: pins,
                blockstore: blockstore,
                root: root,
                loadCodec: loadCodec
              }));

            case 8:
              markedSet = _context.sent;
              blockKeys = blockstore.queryKeys({});
              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(deleteUnmarkedBlocks({
                blockstore: blockstore
              }, markedSet, blockKeys)), _awaitAsyncGenerator), "t0", 11);

            case 11:
              log("Complete (".concat(Date.now() - start, "ms)"));

            case 12:
              _context.prev = 12;
              release();
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5,, 12, 15]]);
    }));
    return _gc.apply(this, arguments);
  }

  return gc;
}

function createMarkedSet(_x4) {
  return _createMarkedSet.apply(this, arguments);
}

function _createMarkedSet() {
  _createMarkedSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref3) {
    var pins, blockstore, loadCodec, root, mfsSource, pinsSource, output, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _cid;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            pins = _ref3.pins, blockstore = _ref3.blockstore, loadCodec = _ref3.loadCodec, root = _ref3.root;
            mfsSource = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var mh, rootCid;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.prev = 0;
                      _context5.next = 3;
                      return _awaitAsyncGenerator(root.get(MFS_ROOT_KEY));

                    case 3:
                      mh = _context5.sent;
                      _context5.next = 12;
                      break;

                    case 6:
                      _context5.prev = 6;
                      _context5.t0 = _context5["catch"](0);

                      if (!(_context5.t0.code === ERR_NOT_FOUND)) {
                        _context5.next = 11;
                        break;
                      }

                      log('No blocks in MFS');
                      return _context5.abrupt("return");

                    case 11:
                      throw _context5.t0;

                    case 12:
                      rootCid = cid.CID.decode(mh);
                      _context5.next = 15;
                      return rootCid;

                    case 15:
                      return _context5.delegateYield(_asyncGeneratorDelegate(_asyncIterator(walkDag.walkDag(rootCid, blockstore, loadCodec)), _awaitAsyncGenerator), "t1", 16);

                    case 16:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, null, [[0, 6]]);
            }))();
            pinsSource = merge__default["default"](map__default["default"](pins.recursiveKeys(), function (_ref6) {
              var cid = _ref6.cid;
              return cid;
            }), pins.indirectKeys(), map__default["default"](pins.directKeys(), function (_ref7) {
              var cid = _ref7.cid;
              return cid;
            }), mfsSource);
            output = new Set();
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context6.prev = 6;
            _iterator = _asyncIterator(merge__default["default"](pinsSource, mfsSource));

          case 8:
            _context6.next = 10;
            return _iterator.next();

          case 10:
            if (!(_iteratorAbruptCompletion = !(_step = _context6.sent).done)) {
              _context6.next = 16;
              break;
            }

            _cid = _step.value;
            output.add(base32.base32.encode(_cid.multihash.bytes));

          case 13:
            _iteratorAbruptCompletion = false;
            _context6.next = 8;
            break;

          case 16:
            _context6.next = 22;
            break;

          case 18:
            _context6.prev = 18;
            _context6.t0 = _context6["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context6.t0;

          case 22:
            _context6.prev = 22;
            _context6.prev = 23;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context6.next = 27;
              break;
            }

            _context6.next = 27;
            return _iterator.return();

          case 27:
            _context6.prev = 27;

            if (!_didIteratorError) {
              _context6.next = 30;
              break;
            }

            throw _iteratorError;

          case 30:
            return _context6.finish(27);

          case 31:
            return _context6.finish(22);

          case 32:
            return _context6.abrupt("return", output);

          case 33:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[6, 18, 22, 32], [23,, 27, 31]]);
  }));
  return _createMarkedSet.apply(this, arguments);
}

function deleteUnmarkedBlocks(_x, _x2, _x3) {
  return _deleteUnmarkedBlocks.apply(this, arguments);
}

function _deleteUnmarkedBlocks() {
  _deleteUnmarkedBlocks = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, markedSet, blockKeys) {
    var blockstore, blocksCount, removedBlocksCount, removeBlock;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            blockstore = _ref4.blockstore;
            blocksCount = 0;
            removedBlocksCount = 0;

            removeBlock = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cid) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", /*#__PURE__*/function () {
                          var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                            var b32, msg;
                            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    blocksCount++;
                                    _context2.prev = 1;
                                    b32 = base32.base32.encode(cid.multihash.bytes);

                                    if (!markedSet.has(b32)) {
                                      _context2.next = 5;
                                      break;
                                    }

                                    return _context2.abrupt("return", null);

                                  case 5:
                                    _context2.prev = 5;
                                    _context2.next = 8;
                                    return blockstore.delete(cid);

                                  case 8:
                                    removedBlocksCount++;
                                    _context2.next = 14;
                                    break;

                                  case 11:
                                    _context2.prev = 11;
                                    _context2.t0 = _context2["catch"](5);
                                    return _context2.abrupt("return", {
                                      err: new Error("Could not delete block with CID ".concat(cid, ": ").concat(_context2.t0.message))
                                    });

                                  case 14:
                                    return _context2.abrupt("return", {
                                      cid: cid
                                    });

                                  case 17:
                                    _context2.prev = 17;
                                    _context2.t1 = _context2["catch"](1);
                                    msg = "Could delete block with CID ".concat(cid);
                                    log(msg, _context2.t1);
                                    return _context2.abrupt("return", {
                                      err: new Error(msg + ": ".concat(_context2.t1.message))
                                    });

                                  case 22:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, null, [[1, 17], [5, 11]]);
                          }));

                          function remove() {
                            return _remove.apply(this, arguments);
                          }

                          return remove;
                        }());

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function removeBlock(_x5) {
                return _ref5.apply(this, arguments);
              };
            }();

            return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(itPipe.pipe(parallelBatch__default["default"](map__default["default"](blockKeys, removeBlock), BLOCK_RM_CONCURRENCY), function (source) {
              return filter__default["default"](source, Boolean);
            })), _awaitAsyncGenerator), "t0", 5);

          case 5:
            log("Marked set has ".concat(markedSet.size, " unique blocks. Blockstore has ").concat(blocksCount, " blocks. ") + "Deleted ".concat(removedBlocksCount, " blocks."));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _deleteUnmarkedBlocks.apply(this, arguments);
}

exports.gc = gc;